import React from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import RestaurantDeliverySlots from "../Restaurant/Components/RestaurantDeliverySlots";

function DeliverySlots() {
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header
          name={"Pre-booking Delivery Slots"}
          subHeading={"Configure delivery pre-booking slots globally"}
        />
        <NavBar />
        <div className="content-body" style={{ minHeight: "80vh", padding: "30px" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <RestaurantDeliverySlots />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default DeliverySlots;
